import { render, staticRenderFns } from "./CartReminderBar.vue?vue&type=template&id=50f75c88&scoped=true"
import script from "./CartReminderBar.vue?vue&type=script&lang=js"
export * from "./CartReminderBar.vue?vue&type=script&lang=js"
import style0 from "./CartReminderBar.vue?vue&type=style&index=0&id=50f75c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f75c88",
  null
  
)

export default component.exports